/** URL slug → the discipline value the backend validates against ExpertCategory. */
export const DISCIPLINE_BY_SLUG: Record<string, string> = {
  "personal-trainer": "personal_trainer",
  physiotherapist: "physiotherapist",
  psychologist: "psychologist",
  "trained-listener": "trained_listener",
};

export const DISCIPLINE_LABEL: Record<string, string> = {
  personal_trainer: "personal trainer",
  physiotherapist: "physiotherapist",
  psychologist: "psychologist",
  trained_listener: "trained listener",
};

/**
 * Meta Pixel for the join flow, supplied by the marketing team.
 *
 * Hardcoded rather than an env var: it is a public identifier that appears in the
 * page source anyway, and putting it behind configuration means a missing
 * variable silently stops attribution in production with nothing to notice.
 */
export const META_PIXEL_ID = "1357744719886626";

/**
 * The marketing team's application form — where this flow starts.
 *
 * Linked from the dead-end card, which is reached by an applicant who opened the
 * join page directly or came back on a spent link. Telling them to "head back to
 * the application form" without a way to get there is a dead end in the literal
 * sense.
 */
const APPLICATION_FORM_ORIGIN = "https://go.jfitconnect.com";

/** Fallback for a caller with no discipline in hand. */
export const APPLICATION_FORM_URL = `${APPLICATION_FORM_ORIGIN}/`;

/**
 * The landing page for one discipline. Their four pages sit at the same slugs
 * this flow uses — confirmed by the marketing team, previously inferred from the
 * `source` field their form posts — so the mapping is one to one.
 *
 * Sending someone back to the root would make them choose a discipline they have
 * already chosen once. Unrecognised slugs cannot reach here (the route 404s
 * first), but fall back to the root rather than building a URL that may not exist.
 */
export function applicationFormUrl(slug?: string): string {
  return slug && slug in DISCIPLINE_BY_SLUG
    ? `${APPLICATION_FORM_ORIGIN}/${slug}`
    : APPLICATION_FORM_URL;
}

/** Same URLs the mobile app links to, so terms are consistent across web and app. */
export const TERMS_URL = "https://jfitconnect.com/terms-of-use/";
export const PRIVACY_URL = "https://jfitconnect.com/privacy-policy/";

export const APP_STORE_URL = "https://apps.apple.com/app/id6759238390";
export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.jfitconnect.app";
export const SUPPORT_EMAIL = "support@jfitconnect.com";
